/**
 * Renders a pop out chat widget in the bottom right of a page.
 */

import React from 'react';
import { useState, useEffect } from 'react';

import AskChat from './askChat';
import * as styles from 'src/uglib_styles/askChatTab.module.css'


function AskChatTab () {

    let [tab_state, setTabState] = useState('collapsed');

    const toggle = () => {

        if(tab_state === "collapsed") {
            setTabState("expanded");
        }
        else {
            setTabState("collapsed");
        }
    }    

    useEffect(() => {
        window.askus_popout_toggle = function() {
            toggle();
        }
    
        const chat_links = document.querySelectorAll('.ug-askus-toggle');
        chat_links.forEach((element) => {element.addEventListener('click', window.askus_popout_toggle)});
    })
   

    const button_styles = ["btn", "btn-primary", styles.toggle].join(' ');
    return (<>

        <div id={styles.askus_popout} data-askus-popout-state={tab_state}>
            <button className={button_styles} onClick={toggle}><span className="fa fa-comment"></span><span className={styles.toggle_label}>Chat with the Library</span></button>
            <div className="askus_tab">
                <AskChat />
            </div>
        </div> 
    </>);
     
}
 
export default AskChatTab